import React from "react";
import { Route, Redirect } from "react-router-dom";

export default ({ component: C, props: cProps, ...rest }) => {
  return (
  <Route
    {...rest}
    render={props =>
      cProps.isLoggedIn || (cProps.isSubLoginType && props.match.path === "/PMProjects/newPMProject") ? (
        <C {...props} {...cProps} />
      ) : (
        <Redirect
          to={`/signIn?redirect=${props.location.pathname}${
            props.location.search
          }${props.location.hash}`}
        />
      )
    }
  />
  )
};
